import { Image, Table, TableColumnsType } from "antd";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import usePassengerWalletDetail from "hooks/passengerWallets/usePassengerWalletDetail";
import { IPassengerWalletHistory } from "models/passengerWallet";
import moment from "moment";
import AlterBy from "./components/AlterBy";
import WalletStatus from "./components/WalletStatus";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import ViewIcon from "components/Icons/ViewIcon";

export default function PassengerWalletDetail() {
  const {
    data: { data, loading, page, per_page, total },
    handlePageChange,
  } = usePassengerWalletDetail();

  return (
    <div className="w-full">
      <div className="w-full mt-8 px-4 text-start">
        {data?.passenger && (
          <div className="w-full flex gap-x-3 items-center flex-wrap">
            <Image
              src={data?.passenger.image || "/images/avatar.png"}
              preview={false}
              height={100}
              width={100}
              className="rounded-full w-24 h-24"
            />
            <div className="flex flex-col gap-1 text-start">
              <p className="capitalize font-bold text-black text-lg">
                {data.passenger.first_name} {data.passenger.last_name}
              </p>
              <p className="text-gray-500 text-sm">{data.passenger.phone}</p>
            </div>
            
            <div className="flex flex-col gap-1 ml-10 text-start">
              <p className="capitalize font-medium text-black text-base">
                Balance
              </p>
              <p
                className={`${
                  data.balance > 0 ? "text-green-500" : "text-red-500"
                } text-sm font-bold`}
              >
                {data.balance.toFixed(2)} Br
              </p>
            </div>
          </div>
        )}
        <div className="w-full flex items-center justify-start mt-7">
            <Link
              to={RouteName.PASSENGER_DETAIL.replace(":id", data.passenger_id)}
              className="rounded-ful hover:text-white flex items-center gap-2 px-10 bg-black text-white py-2 rounded-lg"
            >
              <ViewIcon /> Passenger
            </Link>
        </div>
        <div className="mt-10">
            <Table
            loading={loading}
            columns={columns}
            dataSource={data.histories}
            onChange={handlePageChange}
            pagination={{
                total,
                pageSize: per_page,
                current: page,
                nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                    <NextIcon />
                </span>
                ),
                prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                    <PreviousIcon />
                </span>
                ),
            }}
            />
        </div>
      </div>
    </div>
  );
}

const columns: TableColumnsType<IPassengerWalletHistory> = [
  {
    title: "Amount",
    dataIndex: "amount",
    render: (value: number) => <p>{value.toFixed(2)} Br</p>,
  },
  {
    title: "Status",
    dataIndex: "type",
    render: WalletStatus,
  },
  {
    title: "Alter By",
    render: AlterBy,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value: string) => (
      <p>{moment(value).format("MMM D, YYYY h:mm A")}</p>
    ),
  },
];
